import { render } from "./CalendarWidget.vue?vue&type=template&id=16edceba"
import script from "./CalendarWidget.vue?vue&type=script&lang=js"
export * from "./CalendarWidget.vue?vue&type=script&lang=js"

import "./CalendarWidget.vue?vue&type=style&index=0&id=16edceba&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__